import { gql } from 'graphql-request'

const GET_CREATORS = gql`
  query getCreators(
    $limit: Int
    $offset: Int
    $search: String
    $creator_categories: [bigint!]
  ) {
    creators(
      limit: $limit
      offset: $offset
      where: {
        _and: [
          { account_status: { _eq: "active" } }
          { creator_category_id: { _in: $creator_categories } }
          { deleted: { _nin: ["true"] } }
          {
            _or: [
              { products: { status: { _eq: "active" } } }
              { creator_surveys: { visible: { _eq: true } } }
            ]
          }
          { _or: [{ nickname: { _ilike: $search } }] }
        ]
      }
    ) {
      id
      slug
      nickname
      description
      avatar: avatar_link
    }
  }
`

export default GET_CREATORS
